import * as Period from '../../../../constants/Period';
var WHATWHEREWHEN_PERIOD_MAP = {};
WHATWHEREWHEN_PERIOD_MAP[2800] = Period.NOT_STARTED;
WHATWHEREWHEN_PERIOD_MAP[2801] = Period.FIRST;
WHATWHEREWHEN_PERIOD_MAP[2802] = Period.FINISHED;
export default WHATWHEREWHEN_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/WhatWhereWhen/PeriodMap.js